import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { IMAGES } from '../app.constants';

import { AuthenticationService } from '../_services/authentication.service';
import { CompanyService } from '../_services/company.service';

import { getErrorMessage, getDetailedErrorMessage, getFieldErrorMessage, getCompanyBureauUrl, isGrantsBureauId } from 'app/_utils/helpers';
import { GRANTS_BUREAU_NAME } from 'app/app.constants';
import { Bureau } from '../_models/bureau.model';

@Component({
  selector: 'app-base',
  template: `<div></div>`,
})
export class BaseComponent {
  public IMAGES: any;

  constructor(
    protected router: Router,
    protected authenticationService: AuthenticationService,
    protected companyService: CompanyService,
  ) {
    this.IMAGES = IMAGES;
  }

  getTimezoneId() {
    return this.authenticationService.timezone_id();
  }

  getCurrentCompanyId() {
    return this.authenticationService.current_company_id();
  }

  getCurrentCompanyName() {
    return this.authenticationService.current_company_name();
  }

  getCurrentBureauId() {
    return this.authenticationService.current_bureau_id();
  }

  getCurrentBureauName() {
    return this.authenticationService.current_bureau_name();
  }

  getCompany() {
    return this.companyService.getCompany(this.getCurrentCompanyId());
  }

  getCompanyName() {
    const company = this.getCompany();
    return company ? company.name : '';
  }

  getBureau(): Bureau | null {
    if (this.isGrantsMode()) {
      return null;
    }
    return this.companyService.getBureau(this.getCurrentCompanyId(), this.getCurrentBureauId());
  }

  getBureauName() {
    if (this.isGrantsMode()) {
      return GRANTS_BUREAU_NAME;
    }
    const bureau = this.getBureau();
    return bureau ? bureau.name : '';
  }

  isGrantsMode(): boolean {
    return isGrantsBureauId(this.getCurrentBureauId());
  }

  companyHasGrantsAccess(company: any): boolean {
    return !!(company && company.access_grants_sponsorships);
  }

  companyHasBureauAccess(company: any): boolean {
    return company?.access_bureau !== false;
  }

  getCompanyModuleUrl(module) {
    return `${module}.${this.getCompanyName()}`;
  }

  getCompanyBureauModuleUrl(module) {
    return `${module}.${this.getCompanyName()}.${this.getBureauName()}`;
  }

  getTitle(item) {
    return this.getCurrentBureauName() + '-' + item;
  }

  url(path = '') {
    return this.router.url.split('?')[0] + path;
  }

  // getCurrentFiscalYear() {
  //   return this.companyService.getCurrentFiscalYear(this.getCurrentCompanyId());
  // }

  // getCurrentFiscalYearId() {
  //   const fiscalYear = this.getCurrentFiscalYear();
  //   return fiscalYear ? fiscalYear.id : null;
  // }

  // getCurrentFiscalYearTitle() {
  //   const fiscalYear = this.getCurrentFiscalYear();
  //   return fiscalYear ? fiscalYear.title : '';
  // }

  refresh(router, queryParams: any = {}) {
    const url = decodeURIComponent(router.url.split('?')[0]);
    router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() =>
      router.navigate([url], { queryParams })
    );
  }

  getErrorMessage(err, message = '') {
    return getErrorMessage(err, message);
  }

  getDetailedErrorMessage(err, message = '') {
    return getDetailedErrorMessage(err, message);
  }

  getFieldErrorMessage(err, message = '') {
    return getFieldErrorMessage(err, message);
  }

  getCompanyBureauUrl(url, companyName: string = '', bureauName: string = ''): string {
    if (!companyName) {
      companyName = this.getCurrentCompanyName();
    }
    if (!bureauName) {
      bureauName = this.getCurrentBureauName();
    }
    return getCompanyBureauUrl(url, companyName, bureauName, this.getCurrentBureauId());
  }

  navigate(router, url: string, params = {}, companyName: string = '', bureauName: string = '') {
    if (!companyName) {
      companyName = this.getCurrentCompanyName();
    }
    if (!bureauName) {
      bureauName = this.getCurrentBureauName();
    }
    router.navigate([getCompanyBureauUrl(url, companyName, bureauName, this.getCurrentBureauId())], params);
  }

  navigateRelative(route, url, params = {}) {
    this.router.navigate([url], { relativeTo: route, ...params });
  }

  getEventUrl(eventId: string, url: string = '', companyName: string = '', bureauName: string = '') {
    return this.getCompanyBureauUrl("/events/" + eventId + (url ? '/' + url : ''), companyName, bureauName);
  }

  getNonBureauEventUrl(eventId: string, url: string = '', companyName: string = '', bureauName: string = '') {
    return this.getCompanyBureauUrl("/non-bureau/events/" + eventId + (url ? '/' + url : ''), companyName, bureauName);
  }

  extendLists(list: any[], values: string[]) {
    const items = list || [];
    (values || []).forEach(value => {
      if (value && !items.map(r => r.value).includes(value)) {
        items.push({ value });
      }
    });
    return items;
  }

  extendList(list: any[], value: string) {
    if (value && !list.map(r => r.value).includes(value)) {
      list.push({ value });
    }
    return list;
  }

  openInPopup(url: string, width: number = 500, height: number = 500) {
    window.open(url, "popup", `width=${width},height=${height}`);
  }

  openImageInPopup(imageUrl: string) {
    this.openContentPopup(`<img src="${imageUrl}" style="max-width: 100%; max-height: 100%;">`);
  }

  openContentPopup(content: string, width: number = 500, height: number = 500) {
    const myWindow = window.open("", "", `width=${width},height=${height},top=150,left=150`);
    if (myWindow) myWindow.document.write(content);
  }

  openTasksPopup(eventId, card) {
    let url = this.getEventUrl(eventId, 'tasks-popup');
    if (card) {
      url = url + '?card=' + card;
    }
    this.openInPopup(url, 800, 500);
  }

  openNonBureauTasksPopup(eventId, card) {
    let url = this.getNonBureauEventUrl(eventId, 'tasks-popup');
    if (card) {
      url = url + '?card=' + card;
    }
    this.openInPopup(url, 800, 500);
  }
}
